var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerDataCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1E124A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M120-820H840V-620H120V-820ZM790-720A45 45 0 1 0 700-720A45 45 0 1 0 790-720ZM120-520H840V-320H120V-520ZM790-420A45 45 0 1 0 700-420A45 45 0 1 0 790-420ZM200-240H460V-180H200V-240Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerDataCenterIcon);
export default __webpack_public_path__ + "static/media/marker-data-center-icon.251a58dab99ac7b2d06f44922dab7422.svg";
export { ForwardRef as ReactComponent };